<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">保险公司名称:</div>
                <el-input v-model="conditionData.Name" size="small" placeholder="请输入"></el-input>
            </div>
            
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">搜索</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="保险公司名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="address"
                label="保险公司地址"
                align="center"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <!-- <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCompany(scope.row)">删除</el-button> -->
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :visible.sync="isAddDialog" title="新增保险公司" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        保险公司名称:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        保险公司地址:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.address" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                
                <div class="btns">
                    <el-button type="primary" icon="el-icon-check" size="small" @click="addCompany">提交</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :visible.sync="isUpdateDialog" title="编辑用户" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        保险公司名称:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        保险公司地址:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.address" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                
                <div class="btns">
                    <el-button type="primary" icon="el-icon-check" size="small" @click="updateCompany">提交</el-button>
                </div>
            </div>
        </el-dialog>

      
        
    </div>
</template>
<script>
import api from '../../../api/main'
export default {
    name: 'person',
    data () {
        return {
           
            isShow:false,
            totalCount:0,
            isUpdateDialog:false,
            updateData:{}, 
            conditionData:{
                Name:'',
                page:1,
                pageSize:10,
            },
            tableData:[],
            isAddDialog:false,
            addData:{
            },
           
        }
    },
    created(){

    },
    mounted(){
        this.loadingData();

    },
    methods:{
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.queryPagerListBxCompnay(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        isUpdateDialogShow(row){
            this.organization = row.mechanismName;
            this.role = row.roleName;
            this.updateData = row;
            this.isUpdateDialog = true;
        },
        // 重置
        reset(){
            this.conditionData = {
                name:'',
                page: 1,
                pageSize: 10,
            },
            this.loadingData();
        },
        // 弹出新建
        addDialogShow(){
            this.addData={};
            this.organization='';
            this.role='';
            this.isAddDialog = true;
        },
        // 添加用户
        async addCompany(){
            let res  = await api.createBxCompany(this.addData);
            if(res.data.code == '200'){
                this.isAddDialog = false;
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                this.selectData();
            }
        },
        // 更新用户
        async updateCompany(){
            console.log(this.updateData);
            let res  = await api.updateBxCompany(this.updateData);
            if(res.data.code == '200'){
                this.isUpdateDialog = false;
                this.$message({
                    type: 'success',
                    message: '更新成功!'
                });
                this.selectData();
            }
        },
        
        
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
